import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getVehicleAnalytics = async (brandId, modelId, yearId = null, versionId = null, context = {}, options = {}) => {
  if (!brandId || !modelId || (!context.activeUnitId && !context.dealershipId)) {
    return null;
  }

  try {
    const getAnalyticsFn = httpsCallable(functions, 'getVehicleAnalyticsV2');
    const result = await getAnalyticsFn({
      brandId,
      modelId,
      yearId,
      versionId,
      operatingUnitId: context.activeUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
      view: options.view,
      dateFrom: options.dateFrom,
      dateTo: options.dateTo,
      plateSearch: options.plateSearch ?? '',
      auctionIds: options.auctionIds,
    });

    if (result.data) {
      if (result.data.success === 'yes') {
        return result.data.data;
      }
      if (result.data.success === undefined) {
        return result.data;
      }
    }
    return null;
  } catch (error) {
    console.error('Error obteniendo analítica de vehículos:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
